import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type StaffUser = {
  id: number;
  nombre: string;
  apellido: string;
  email: string;
  telefono?: string | null;
  rol: string;
  area_nombre: string | null;
  area_icono?: string | null;
  municipio_nombre: string | null;
  municipio_id: number;
};

type StaffAuthStore = {
  accessToken:  string | null;
  refreshToken: string | null;
  staff:        StaffUser | null;
  setSession:   (access: string, refresh: string, staff: StaffUser) => void;
  logout:       () => void;
};

export const useStaffAuth = create<StaffAuthStore>()(
  persist(
    (set) => ({
      accessToken:  null,
      refreshToken: null,
      staff:        null,
      setSession:   (access, refresh, staff) =>
        set({ accessToken: access, refreshToken: refresh, staff }),
      logout: () => set({ accessToken: null, refreshToken: null, staff: null }),
    }),
    { name: 'ciudadapp-staff-auth' }
  )
);
